const { isDataURL } = require('../../helpers/dataUrl');
const ImagesFactory = require('../factory/images');
const templates = {
  container: require('./templates/filterpicker/container.hbs'),
  SVGImageFiltred: require('./templates/filterpicker/svg-image-filtred.hbs')
};

(function ($) {
  if (INKIVE.C.IS_MOBILE_APP) {
    return;
  }

  $.fn.extend({
    filterpicker: function (options) {
      let modal; let $container; const dataImagesCache = {};
      const NS = window.NAMESPACE_URIS.SVG;

      options = $.extend({
        defaultFilter: null,
        $svgImageElement: null
      }, options);

      const t = function (key) {
        return INKIVE.TranslateHelper.translate('popupmenu.filters.' + key);
      };

      const presets = [
        { name: t('normal'), className: 'thumb-normal', template: _.template('<feColorMatrix type="saturate" values="1"></feColorMatrix>') },
        { name: t('cali'), className: 'thumb-cali', template: require('./templates/filterpicker/filter-cali.hbs') },
        { name: t('drama'), className: 'thumb-drama', template: require('./templates/filterpicker/filter-drama.hbs') },
        { name: t('edge'), className: 'thumb-edge', template: require('./templates/filterpicker/filter-edge.hbs') },
        { name: t('epic'), className: 'thumb-epic', template: require('./templates/filterpicker/filter-epic.hbs') },
        { name: t('festive'), className: 'thumb-festive', template: require('./templates/filterpicker/filter-festive.hbs') },
        { name: t('grayscale'), className: 'thumb-grayscale', template: require('./templates/filterpicker/filter-grayscale.hbs') },
        { name: t('nordic'), className: 'thumb-nordic', template: require('./templates/filterpicker/filter-nordic.hbs') },
        { name: t('street'), className: 'thumb-street', template: require('./templates/filterpicker/filter-street.hbs') },
        { name: t('blues'), className: 'thumb-the-blues', template: require('./templates/filterpicker/filter-the-blues.hbs') }
      ];

      const input = {
        to: {
          hue: function (value) { return normalize(value, -180, 180); },
          blur: function (value) { return normalize(value, -10, 10); },
          sharpen: function (value) { return normalize(value, -1, 1) * -1; },
          contrast: function (value) { return normalize(value, 0, 2); },
          brightness: function (value) { return normalize(value, 0, 2); },
          saturation: function (value) { return normalize(value, 0, 2); },
          matrixSaturation: function (value) { return normalize(value, -1, 1); },
          vignetteOpacity: function (value) { return 0.7 + normalize(value, 0, 0.3, 0, 100); },
          vignetteSpecular: function (value) { return normalize(value, 0, 30, 0, 100); }
        },

        from: {
          hue: function (value) { return inverseNormalize(value, -180, 180); },
          blur: function (value) { return inverseNormalize(value, -10, 10); },
          sharpen: function (value) { return inverseNormalize(value, -1, 1) * -1; },
          contrast: function (value) { return inverseNormalize(value, 0, 2); },
          brightness: function (value) { return inverseNormalize(value, 0, 2); },
          saturation: function (value) { return inverseNormalize(value, 0, 2); },
          matrixSaturation: function (value) { return inverseNormalize(value, -1, 1); },
          vignetteSpecular: function (value) { return normalize(value, 0, 100, 0, 30); }
        }
      };

      function inverseNormalize (value, outMin, outMax) {
        return normalize(value, -100, 100, outMin, outMax);
      }

      function normalize (value, outMin, outMax, inMin, inMax) {
        value = parseFloat(value);
        inMin = typeof inMin === 'undefined' ? -100 : inMin;
        inMax = typeof inMax === 'undefined' ? 100 : inMax;

        const inRange = inMax - inMin;
        const percent = (value - inMin) / inRange;
        const outRange = outMax - outMin;

        return outMin + outRange * percent;
      }

      function getSaturation () {
        const value = $container.find('.slider-wrapper.saturation-slider-wrapper input').val();
        if (value === 0) return;

        const colorMatrix = document.createElementNS(NS, 'feColorMatrix');

        if (value < 0) {
          colorMatrix.setAttribute('type', 'saturate');
          colorMatrix.setAttribute('values', input.to.saturation(value));
        } else {
          const normalizedValue = input.to.matrixSaturation(value);
          const lowExtremes = -0.3 * normalizedValue;
          const highExtrem = 1 + 0.7 * normalizedValue;

          colorMatrix.setAttribute('type', 'matrix');
          colorMatrix.setAttribute('values',
            highExtrem + ' ' + lowExtremes + ' ' + lowExtremes + ' 0 0 ' +
                        lowExtremes + ' ' + highExtrem + ' ' + lowExtremes + ' 0 0 ' +
                        lowExtremes + ' ' + lowExtremes + ' ' + highExtrem + ' 0 0 ' +
                        '0 0 0 1 0'
          );
        }

        return colorMatrix;
      }

      function getBlur () {
        const value = $container.find('.slider-wrapper.blur-slider-wrapper input').val();
        if (value === 0) return;

        if (value > 0) {
          const gaussianBlur = document.createElementNS(NS, 'feGaussianBlur');
          gaussianBlur.setAttribute('stdDeviation', input.to.blur(value));

          return gaussianBlur;
        } else {
          const normalizedValue = input.to.sharpen(value);
          const lowExtremes = -1 * normalizedValue;
          const highExtrem = 1 + 4 * normalizedValue;
          const convolveMatrix = document.createElementNS(NS, 'feConvolveMatrix');
          convolveMatrix.setAttribute('order', '3 3');
          convolveMatrix.setAttribute('preserveAlpha', 'true');
          convolveMatrix.setAttribute('kernelMatrix', '0 ' + lowExtremes + ' 0 ' + lowExtremes + ' ' + highExtrem + ' ' + lowExtremes + ' 0 ' + lowExtremes + ' 0');
          return convolveMatrix;
        }
      }

      function getBrightness () {
        const value = $container.find('.slider-wrapper.brightness-slider-wrapper input').val();
        if (value === 0) return;

        const normalizedValue = input.to.brightness(value);
        const componentTransfer = document.createElementNS(NS, 'feComponentTransfer');

        _.each(['R', 'G', 'B'], function (colorComponent) {
          const colorFunction = document.createElementNS(NS, 'feFunc' + colorComponent);
          colorFunction.setAttribute('type', 'linear');
          colorFunction.setAttribute('slope', normalizedValue);
          componentTransfer.appendChild(colorFunction);
        });

        return componentTransfer;
      }

      function getContrast () {
        const value = $container.find('.slider-wrapper.contrast-slider-wrapper input').val();
        if (value === 0) return;

        const normalizedValue = input.to.contrast(value);
        const intercept = 0.5 - 0.5 * normalizedValue;
        const componentTransfer = document.createElementNS(NS, 'feComponentTransfer');

        _.each(['R', 'G', 'B'], function (colorComponent) {
          const colorFunction = document.createElementNS(NS, 'feFunc' + colorComponent);
          colorFunction.setAttribute('type', 'linear');
          colorFunction.setAttribute('slope', normalizedValue);
          colorFunction.setAttribute('intercept', intercept);
          componentTransfer.appendChild(colorFunction);
        });

        return componentTransfer;
      }

      function getHue () {
        const value = $container.find('.slider-wrapper.x-process-slider-wrapper input').val();
        if (value === 0) return;

        const colorMatrix = document.createElementNS(NS, 'feColorMatrix');

        colorMatrix.setAttribute('type', 'hueRotate');
        colorMatrix.setAttribute('values', input.to.hue(value));

        return colorMatrix;
      }

      function getVignette (filterId, $image) {
        const value = $container.find('.slider-wrapper.vignette-slider-wrapper input').val();
        if (value === 0) return;

        const specularValue = input.to.vignetteSpecular(value);
        const coord = getImagePosition();

        const flood = document.createElementNS(NS, 'feFlood');
        const pointLight = document.createElementNS(NS, 'fePointLight');
        const specularLighting = document.createElementNS(NS, 'feSpecularLighting');
        const blend1 = document.createElementNS(NS, 'feBlend');
        const blend2 = document.createElementNS(NS, 'feBlend');

        flood.setAttribute('result', 'blackfield-' + filterId);
        flood.setAttribute('x', coord.leftOffset + 'px');
        flood.setAttribute('y', coord.topOffset + 'px');
        flood.setAttribute('width', coord.width + 'px');
        flood.setAttribute('height', coord.height + 'px');

        pointLight.setAttribute('x', coord.leftOffset + coord.width / 2);
        pointLight.setAttribute('y', coord.topOffset + coord.height / 2);
        pointLight.setAttribute('z', _.min([coord.width, coord.height]));

        specularLighting.setAttribute('result', 'spotlight-' + filterId);
        specularLighting.setAttribute('lighting-color', '#FFFFFF');
        specularLighting.setAttribute('surfaceScale', '1');
        specularLighting.setAttribute('specularConstant', '1');
        specularLighting.setAttribute('specularExponent', specularValue);
        specularLighting.setAttribute('x', coord.leftOffset + 'px');
        specularLighting.setAttribute('y', coord.topOffset + 'px');
        specularLighting.setAttribute('width', coord.width + 'px');
        specularLighting.setAttribute('height', coord.height + 'px');
        specularLighting.appendChild(pointLight);

        blend1.setAttribute('result', 'A-' + filterId);
        blend1.setAttribute('in', 'blackfield-' + filterId);
        blend1.setAttribute('in2', 'spotlight-' + filterId);
        blend1.setAttribute('mode', 'lighten');

        blend2.setAttribute('result', 'B-' + filterId);
        blend2.setAttribute('in', 'A-' + filterId);
        blend2.setAttribute('in2', 'SourceGraphic');
        blend2.setAttribute('mode', 'multiply');

        return [flood, specularLighting, blend1, blend2];

        function getImagePosition () {
          $image = $image || options.$svgImageElement;
          if ($image.hasClass('layoutBox')) {
            const imageCoordinades = $image.get(0).dataset.boxCoordinates.split(' ');

            return {
              leftOffset: parseFloat(imageCoordinades[0]),
              topOffset: parseFloat(imageCoordinades[1]),
              width: parseFloat(imageCoordinades[2]),
              height: parseFloat(imageCoordinades[3])
            };
          }

          return {
            leftOffset: parseFloat($image.attr('x')),
            topOffset: parseFloat($image.attr('y')),
            width: parseFloat($image.attr('width')),
            height: parseFloat($image.attr('height'))
          };
        }
      }

      function getSVGDefs () {
        const defs = document.createElementNS(NS, 'defs');
        const $svgContainer = options.$svgImageElement.closest('svg');
        $svgContainer.children('defs').length || $svgContainer.prepend(defs);

        return $svgContainer.children('defs').get(0);
      }

      function createNewFilterPickerContainer () {
        const deferred = $.Deferred();
        $container = $(templates.container());

        getImageSource().then(function (image) {
          $container.on('change', onContainerChange);
          $container.tabs();

          initPresets(image);
          initImage(image);
          deferred.resolve();
        });

        return deferred.promise();

        function initPresets (image) {
          const $presetsContainer = $container.find('.presets-container');

          _.each(presets, function (preset) {
            const filterId = 'filter-thumb-' + preset.className;
            const filter = preset.template({ filter_id: filterId });
            const $filtredThumb = $('<li>', {
              class: 'thumb ' + preset.className,
              html: templates.SVGImageFiltred({
                width: 110,
                height: 110,
                image,
                filter_id: filterId,
                filter
              })
            });

            $filtredThumb.append('<span class="filter-name">' + preset.name + '</span>');
            $presetsContainer.append($filtredThumb);
          });
        }

        function initImage (image) {
          const $svgContainer = $container.find('.svg-container');

          $(templates.SVGImageFiltred({
            width: 400,
            height: 400,
            image,
            filter_id: 'filtered-image-preview',
            filter: _.findWhere(presets, { className: 'thumb-normal' }).template()
          })).appendTo($svgContainer);
        }
      }

      function getOptimusSizeInfo ($svgContainer, securityMargin) {
        securityMargin = securityMargin || 0;
        const svgContainerWidth = ($svgContainer.width() || 400) + securityMargin;
        const svgContainerHeight = ($svgContainer.height() || 400) + securityMargin;
        const containerRatio = svgContainerWidth / svgContainerHeight;

        const originalWidth = parseInt(options.$svgImageElement.attr('width'));
        const originalHeight = parseInt(options.$svgImageElement.attr('height'));
        const ratio = originalWidth / originalHeight;

        return {
          width: ratio > containerRatio ? svgContainerHeight * ratio : svgContainerWidth,
          height: ratio > containerRatio ? svgContainerHeight : svgContainerWidth / ratio
        };
      }

      function updatePreview () {
        getImageSource().then(function (image) {
          const $svgContainer = $container.find('.svg-container');
          const $previewImage = $svgContainer.find('image');
          const size = getOptimusSizeInfo($svgContainer, 4);

          $previewImage.attr('xlink:href', image);
          $previewImage.attr('width', size.width);
          $previewImage.attr('height', size.height);
          $svgContainer.find('svg').attr('width', size.width);
          $svgContainer.find('svg').attr('height', size.height);
        });
      }

      function updateCarousel () {
        const $presetsContainer = $container.find('.presets-container');

        $presetsContainer.hasClass('slick-slider') && $presetsContainer.slick('unslick');
        $presetsContainer.slick({
          prevArrow: '<span class="prev btn btn-green"><i class="icon-chevron-left"></i></span>',
          nextArrow: '<span class="next btn btn-green"><i class="icon-chevron-right"></i></span>',
          infinite: true,
          slidesToShow: 4,
          slidesToScroll: 2
        });
      }

      function updatePresets () {
        getImageSource().then(function (image) {
          const $presetsContainer = $container.find('.presets-container');
          const $svgContainer = $presetsContainer.find('li');
          const $previewImage = $svgContainer.find('image');

          $previewImage.attr('xlink:href', image);

          $presetsContainer.hide();
          INKIVE.Modal.loader($presetsContainer.parent());

          $presetsContainer.hasClass('slick-slider') && $presetsContainer.slick('slickGoTo', 0);

          _.delay(function () {
            $svgContainer.width($svgContainer.width() || $svgContainer.height());

            INKIVE.Modal.loaderClose($presetsContainer.parent());
            $presetsContainer.show();
            updateCarousel();

            const size = getOptimusSizeInfo($svgContainer, 2);
            $previewImage.attr('width', size.width);
            $previewImage.attr('height', size.height);
            $svgContainer.find('svg').attr('width', size.width);
            $svgContainer.find('svg').attr('height', size.height);

            modal && modal.refresh();
          }, 2000);
        });
      }

      function updateSliders ($filter) {
        const fr = input.from;
        const $slidersContainer = $container.find('.sliders-container');

        initSliders();

        $slidersContainer.find('.blur-slider-wrapper input').val(getBlurFromFilter());
        $slidersContainer.find('.x-process-slider-wrapper input').val(getHueFromFilter());
        $slidersContainer.find('.vignette-slider-wrapper input').val(getVignetteFromFilter());
        $slidersContainer.find('.contrast-slider-wrapper input').val(getContrastFromFilter());
        $slidersContainer.find('.brightness-slider-wrapper input').val(getBrightnessFromFilter());
        $slidersContainer.find('.saturation-slider-wrapper input').val(getSaturationFromFilter());
        $slidersContainer.find('input').trigger('keyup');

        function initSliders () {
          const translate = INKIVE.TranslateHelper.translate;
          $slidersContainer.empty();

          // addNewSlider('intensity', -100, 100, 0);
          addNewSlider('brightness', -100, 100);
          addNewSlider('contrast', -100, 100);
          addNewSlider('saturation', -100, 100);
          // addNewSlider('tint', -100, 100, 0);
          addNewSlider('blur', -100, 100);
          addNewSlider('x-process', -100, 100);
          addNewSlider('vignette', 0, 100);

          function addNewSlider (label, min, max, currentValue) {
            currentValue = isNaN(currentValue) ? 0 : Math.round(currentValue);

            const $sliderWrapper = $('<div class="slider-wrapper"><div class="slider"></div></div>');
            const $sliderInput = $('<input type="text" />').val(currentValue);

            $sliderWrapper.append($sliderInput);
            $sliderWrapper.addClass(label + '-slider-wrapper');
            $slidersContainer.append($sliderWrapper);

            $sliderInput.on('click', function (event) {
              event.stopPropagation();
            });

            $sliderInput.keyup(function (event) {
              let val = parseInt($(this).val()) || 0;

              if (val > max) val = max;
              else if (val < min) val = min;

              $(this).val(val);

              slider.slider('option', 'value', val);
              $container.trigger('change');
            });

            var slider = $sliderWrapper.children('.slider').slider({
              max,
              min,
              value: currentValue,
              slide: function (event, ui) {
                $sliderInput.val(ui.value);
                $container.trigger('change');
              }
            });

            slider.slider('float');
            $sliderWrapper.prepend($('<label>', {
              text: translate('filterpicker.sliders.' + label)
            }));
          }
        }

        function getBrightnessFromFilter () {
          const $brightness = $filter.find('feComponentTransfer feFuncR:not([intercept])');
          return $brightness.length
            ? fr.brightness($brightness.attr('slope'))
            : 0;
        }

        function getContrastFromFilter () {
          const $contrast = $filter.find('feComponentTransfer feFuncR[intercept]');
          return $contrast.length
            ? fr.contrast($contrast.attr('slope'))
            : 0;
        }

        function getSaturationFromFilter () {
          const $negativeSaturation = $filter.find('feColorMatrix[type="saturate"]');
          const $matrixSaturation = $filter.find('feColorMatrix[type="matrix"]');

          if ($negativeSaturation.length) {
            return fr.saturation($negativeSaturation.attr('values'));
          }

          if ($matrixSaturation.length) {
            const saturation = $matrixSaturation.attr('values');
            return fr.matrixSaturation((saturation.split(' ')[0] - 1) / 0.7);
          }

          return 0;
        }

        function getHueFromFilter () {
          const $hue = $filter.find('feColorMatrix[type="hueRotate"]');
          return $hue.length
            ? fr.hue($hue.attr('values'))
            : 0;
        }

        function getVignetteFromFilter () {
          const $vignetteSpecular = $filter.find('feSpecularLighting');
          return $vignetteSpecular.length
            ? fr.vignetteSpecular($vignetteSpecular.attr('specularExponent'))
            : 0;
        }

        function getBlurFromFilter () {
          const $blur = $filter.find('feGaussianBlur');
          const $sharpen = $filter.find('feConvolveMatrix');

          if ($blur.length) {
            return fr.blur($blur.attr('stdDeviation'));
          }

          if ($sharpen.length) {
            const sharpen = $sharpen.attr('kernelMatrix');
            return fr.sharpen(parseFloat(sharpen.split(' ')[1]) * -1);
          }

          return 0;
        }
      }

      function onContainerChange () {
        const $previewFilter = $container.find('#filtered-image-preview');
        const previewFilter = $previewFilter.get(0);
        const $previewImage = $previewFilter.closest('svg').find('image');

        const isFilterUpdated = updateFilter();
        isFilterUpdated && $previewImage.attr('filter', 'url(#filtered-image-preview)');
        isFilterUpdated || $previewImage.removeAttr('filter');

        function updateFilter () {
          previewFilter.innerHTML = '';

          const filterNodes = _.compact(_.flatten(_.map(
            [getVignette, getSaturation, getBrightness, getContrast, getBlur, getHue],
            function (getFilterFunction) { return getFilterFunction('filtered-image-preview', $previewImage); }
          )));

          _.each(filterNodes, function (node) {
            previewFilter.appendChild(node);
          });

          return filterNodes.length > 0;
        }
      }

      function getImageSource () {
        const deferred = $.Deferred();
        let url = options.$svgImageElement[0].getAttribute('xlink:href');

        if (isDataURL(url)) {
          url = ImagesFactory.getImageUrl(options.$svgImageElement[0]);

          if (dataImagesCache[url]) {
            return dataImagesCache[url].promise();
          }

          dataImagesCache[url] = deferred;
          loadImageOptions([ImagesFactory.getVersionUrl(url, 'tab'), url], deferred.resolve);
        } else {
          deferred.resolve(url);
        }

        return deferred.promise();

        function loadImageOptions (inOrderLoadOptions, onLoad) {
          const img = new Image();
          loadNext();

          img.onload = function () { onLoad(img.src); };
          img.onerror = function () { inOrderLoadOptions.length && loadNext(); };

          function loadNext () {
            img.src = inOrderLoadOptions.shift();
          }
        }
      }

      return this.each(function (e) {
        const imageId = options.$svgImageElement.attr('id');
        const filterId = 'filter_' + imageId;

        modal && modal.close();
        refreshDOM();

        let width = $(window).width() * 0.8;
        if (width > 800) width = 800;

        const translate = INKIVE.TranslateHelper.translate;
        modal = INKIVE.Modal.modalWindow($container, {
          width,
          headerIcon: 'desygner-icon-filters',
          headerTitle: INKIVE.TranslateHelper.translate('popupmenu.dropdown_title.image_filter'),
          buttons: [
            {
              title: translate('editor.apply'),
              onClick: function () {
                applyChanges();
                INKIVE.DesignFacade.trigger('image.filter', imageId);
              }
            }
          ]
        });

        $container.parents('.modal').addClass('allow-margins');
        $container.parents('.modal').addClass('filter-image-popup');

        function refreshDOM () {
          $('#filter-picker').remove();
          createNewFilterPickerContainer().then(function () {
            setSvgImageChangeEvent();
            updateEvents();
            _.defer(setSpecsBasedOnSelectedImage);
          });
        }

        function updateEvents () {
          $container.find('.presets-container li').off('click').on('click', function (event) {
            event.stopPropagation();

            const $previewFilter = $('#filtered-image-preview');
            const $previewImage = $previewFilter.closest('svg').find('image');

            const classes = $(this).attr('class').split(/\s+/);
            const preset = _.find(presets, function (preset) {
              return _.contains(classes, preset.className);
            });

            if (!preset) return;

            $previewFilter.html(preset.template({
              filter_id: 'filtered-image-preview'
            }));

            $previewImage.attr('filter', 'url(#filtered-image-preview)');
            updateSliders($previewFilter);
            $container.trigger('change');
          });

          $container.off('change').on('change', onContainerChange);
        }

        function setSvgImageChangeEvent () {
          const debouncedOnChange = _.debounce(function () {
            $container.trigger('change');
            applyChanges();
          }, 400);

          options.$svgImageElement.on('change', function () {
            if ($('#' + filterId).length) {
              setSpecsBasedOnSelectedImage();
              debouncedOnChange();
            }
          });
        }

        function setSpecsBasedOnSelectedImage () {
          updatePreview();
          updatePresets();
          updateSliders($('#' + filterId));
        }

        function applyChanges () {
          const filterId = 'filter_' + options.$svgImageElement.attr('id');
          const defs = getSVGDefs();

          while ($('#' + filterId).length) {
            $('#' + filterId).remove();
          }

          const isFilterCreated = createNewFilter();

          isFilterCreated && options.$svgImageElement.attr('filter', 'url(#' + filterId + ')');
          isFilterCreated || options.$svgImageElement.removeAttr('filter');

          $('[data-action=on_imageFilter]').toggleClass('applied', isFilterCreated);
          modal && modal.close();

          function createNewFilter () {
            const filter = document.createElementNS(NS, 'filter');
            filter.setAttribute('id', filterId);

            const filterNodes = _.compact(_.flatten(_.map(
              [getVignette, getSaturation, getBrightness, getContrast, getBlur, getHue],
              function (getFilterFunction) { return getFilterFunction(filterId); }
            )));

            _.each(filterNodes, function (node) {
              filter.appendChild(node);
            });

            defs && filterNodes.length && defs.appendChild(filter);
            return filterNodes.length > 0;
          }
        }
      });
    }
  });
})(jQuery);
